
import React from 'react';
import NavigationTab from './NavigationTab';
import ErrorsTab from './ErrorsTab';
import ConsoleTab from './ConsoleTab';
import { getNavigationStats } from '@/utils/navigationMonitor';

interface DiagnosticsTabsProps {
  activeTab: 'navigation' | 'errors' | 'console';
  setActiveTab: (tab: 'navigation' | 'errors' | 'console') => void;
  stats: ReturnType<typeof getNavigationStats>;
  setStats: React.Dispatch<React.SetStateAction<ReturnType<typeof getNavigationStats>>>;
  consoleMessages: Array<{type: string, message: string, timestamp: Date}>;
  setConsoleMessages: React.Dispatch<React.SetStateAction<Array<{type: string, message: string, timestamp: Date}>>>;
}

const DiagnosticsTabs: React.FC<DiagnosticsTabsProps> = ({ 
  activeTab, 
  setActiveTab, 
  stats, 
  setStats,
  consoleMessages,
  setConsoleMessages
}) => {
  return (
    <>
      <div className="flex border-b border-gray-200 dark:border-gray-700 mb-3">
        <button
          className={`px-3 py-1 text-xs ${activeTab === 'navigation' ? 'border-b-2 border-blue-500 font-medium' : 'text-gray-500'}`}
          onClick={() => setActiveTab('navigation')}
        >
          Navigation
        </button>
        <button
          className={`px-3 py-1 text-xs ${activeTab === 'errors' ? 'border-b-2 border-blue-500 font-medium' : 'text-gray-500'}`}
          onClick={() => setActiveTab('errors')}
        >
          Errors
        </button>
        <button
          className={`px-3 py-1 text-xs ${activeTab === 'console' ? 'border-b-2 border-blue-500 font-medium' : 'text-gray-500'}`}
          onClick={() => setActiveTab('console')}
        >
          Console
        </button>
      </div>
      
      {activeTab === 'navigation' && <NavigationTab stats={stats} setStats={setStats} />}
      {activeTab === 'errors' && <ErrorsTab stats={stats} />}
      {activeTab === 'console' && <ConsoleTab consoleMessages={consoleMessages} setConsoleMessages={setConsoleMessages} />}
    </>
  );
};

export default DiagnosticsTabs;
